import React, { ChangeEventHandler, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { CSSTransition } from 'react-transition-group'
import "../../css/Buttons.css"
import "../../css/Transitions.css"
import "../../css/ChooseView.css"
import * as DeviceUtil from "../../utils/DeviceUtil"
import Theme from "../../library/Theme"

interface ChooseViewProps {
  theme: Theme
  handleSwitchDevice: () => void
  handleUserSelectedImage: (file: File) => void
}

function CameraErrorFallbackView({ theme, handleSwitchDevice, handleUserSelectedImage }: ChooseViewProps) {
  const { t } = useTranslation()

  const helpLink = DeviceUtil.isMobileOrTablet() ? "https://help.simplebooth.com/en/articles/4449769-my-phone-s-camera-is-not-working-properly" : "https://help.simplebooth.com/en/articles/4408695-my-computer-s-camera-is-not-working-properly"
  const fileInput = useRef<HTMLInputElement>(null)

  const showImageChooser = () => {
    if (!fileInput.current) {
      return
    }

    fileInput.current.click()
  }

  const handleChosenImage: ChangeEventHandler<HTMLInputElement> = (e) => {
    let file = e.target.files?.item(0) ?? null
    if (!file) {
      return
    }

    handleUserSelectedImage(file)
  }

  return (
    <section>
      <input type="file" ref={fileInput} onChange={handleChosenImage} accept="image/jpg,image/jpeg,image/png" hidden />
      <CSSTransition in appear timeout={1000} classNames="slideDown">
        <div id="headingGroup">
          <h1 style={theme.textStyle}>{t("noCamera.heading")}</h1>
          <button id="chooseImageButton" className="bigButton" style={theme.bigButtonStyle} onClick={showImageChooser}>{t("noCamera.choose")}</button>
          <div className="chooseViewExtras" style={theme.textStyle}>
            <button
              style={{ borderColor: theme.textColor, ...theme.textStyle }}
              onClick={handleSwitchDevice}
            >
              {t("common.switchDevice")}
            </button>
            <a
              style={{ borderColor: theme.textColor, ...theme.textStyle }}
              href={helpLink}
              target="_blank"
              rel="noopener noreferrer">
              {t("noCamera.help")}
            </a>
          </div>
        </div>
      </CSSTransition>
    </section >
  )
}

export default CameraErrorFallbackView
